/**
 * The project card class name
 * @type {String}
 */
export const SAMPLES_SLIDER_CLASSNAME = 'samples-slider';

/**
 * Favorite project card class names.
 * @type {string}
 */
export const FAVORITE_SAMPLES_SLIDER_CLASSNAME = `${SAMPLES_SLIDER_CLASSNAME} favorite-container`;
